import { truncateLength } from "@/components/app-layout/consts";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export function DisplayName({
  name,
  icon,
  colorClassName,
  className,
}: {
  name: string;
  icon: FontAwesomeIconProps["icon"];
  colorClassName?: string;
  className?: string;
}) {
  const isTruncated = name.length > truncateLength;
  const displayName = isTruncated ? `${name.slice(0, truncateLength)}…` : name;

  const nameEl = <div className="truncate">{displayName}</div>;

  return (
    <span className={cn("flex items-center gap-2 overflow-hidden", className)}>
      <FontAwesomeIcon icon={icon} className={colorClassName} />
      {isTruncated ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>{nameEl}</TooltipTrigger>
            <TooltipContent>{name}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        nameEl
      )}
    </span>
  );
}
